import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@scentregroup/ui'

import { Centre } from '../../../types/centre'
import { makeMailUrl } from '../../helpers'
import ExternalLink from '../external-link'
import style from './index.scss'

export const CentreDetails: React.FC<{ centre: Centre }> = ({ centre }) => (
  <>
    <div className={style.centreDetails}>
      <div className={style.centreName}>Westfield {centre.title}</div>
      <div className={style.centreAddress}>
        {centre.physicalAddress} <br />
        {centre.suburb} {centre.state} {centre.postcode} <br />
        <ExternalLink url={`tel:${centre.telephoneNumber}`}>
          {centre.telephoneNumber}
        </ExternalLink>
      </div>
      <ExternalLink
        url={makeMailUrl(centre.emailAddress)}
        className={style.contactConcierge}
      >
        {`Contact ${centre.title} Concierge`}
      </ExternalLink>
      <Link to="/" className={style.centreChangeLink}>
        Change Centre
      </Link>
    </div>
    <div className={style.contactLinks} data-test-id="contact-links">
      {centre.contactLinks.map(
        contact =>
          contact.url && (
            <ExternalLink url={contact.url} key={contact.type}>
              <Icon
                type={contact.type}
                size="medium"
                className={style.socialLogo}
              />
            </ExternalLink>
          )
      )}
    </div>
  </>
)
